<template>
  <GModal
    id="undertone-modal"
    :class="['custom-modal', 'modal-mask', 'modal--undertone', 'modal--newsletter', 'new-form']"
  >
    <div slot="header" class="beauty-profile-header">
      <h4 class="modal-heading">Pretty News For Your Inbox</h4>
    </div>
    <div slot="body">
      <template v-if="!loading">
        <p class="modal-text">Pilih platform yang kamu minati untuk dapatkan updatenya!</p>
        <section class="beauty-profile-section">
          <div class="items newsletter-content">
            <div class="container">
              <div v-for="(list, index) in checkboxList" :key="index" class="field new-checkbox">
                <input
                  :id="`newsletter_${list.name}`"
                  v-model="subscribingList"
                  v-validate="'required'"
                  type="checkbox"
                  :name="`newsletter_${list.name}`"
                  :value="list.value"
                  class="checkbox"
                />
                <label :for="`newsletter_${list.name}`">{{ list.label }}</label>
              </div>
            </div>
            <p v-show="errors.has('newsletter')" class="alert">
              {{ errors.first('newsletter') }}
            </p>
          </div>
        </section>
        <div v-if="!isSubmitNewsletterProcessing" class="button-submit-newsletter-group">
          <!-- <a v-if="isLillaBeautyProfile" href="" class="btn white button-submit-newsletter"
                        @click.prevent="$emit('back')">
                        BACK
                    </a> -->
          <a
            href=""
            class="btn red button-submit-newsletter"
            :class="{ disabled: !isCheckedAtLeastOne }"
            :disabled="!isCheckedAtLeastOne"
            @click.prevent="submitNewsletter"
          >
            Submit
          </a>
        </div>
        <GLoaderSpin v-else></GLoaderSpin>
      </template>
      <GLoaderSpin v-else></GLoaderSpin>
    </div>
  </GModal>
</template>

<script>
// import {startCase, upperCase} from 'lodash'
export default {
  name: 'newsletter-modal',
  // eslint-disable-next-line vue/require-prop-types
  props: ['skipLillaProfile', 'allowFetchNewsletter'],
  data() {
    return {
      loading: true,
      isLillaBeautyProfile: true,
    };
  },
  computed: {
    checkboxList() {
      const list = ['sociolla', 'soco', 'lilla', 'beauty_journal'].map((el, index) => {
        const $label = (el) => {
          switch (el) {
            case 'soco':
              return this.$upperCase(el);
            default:
              return this.$startCase(el);
          }
        };
        return {
          name: `email_${el}`,
          label: $label(el),
          value: el,
        };
      });
      return list;
    },
    isCheckedAtLeastOne() {
      return Boolean(this.$store.state.profile.newsletter.length);
    },
    subscribingList: {
      get() {
        return this.$store.state.profile.newsletter || [];
      },
      set(value) {
        this.$store.commit('newsletter', value);
      },
    },
    isSubmitNewsletterProcessing: {
      get() {
        return this.$store.state.profile.newsletterLoading;
      },
      set(value) {
        this.$store.commit('newsletterLoading', value);
      },
    },
  },
  created() {
    if (this.allowFetchNewsletter) {
      this.fetchNewsletter();
      return;
    }
    this.loading = false;
  },
  methods: {
    fetchNewsletter() {
      this.$store.dispatch('fetchNewsletter', this).then(() => (this.loading = false));
    },
    submitNewsletter() {
      this.$validator.validateAll().then((result) => {
        if (result && this.isCheckedAtLeastOne) {
          this.isSubmitNewsletterProcessing = true;
          this.$store
            .dispatch('registerNewsletter', this)
            .then((response) => {
              if (response) {
                this.$emit('after-submit');
              }
            })
            .finally(() => (this.isSubmitNewsletterProcessing = false));
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
#undertone-modal.modal--newsletter {
  /deep/ .content-wrapper {
    @media (max-width: 1100px) {
      padding: 0 16px;
      width: 100vw;
    }
  }

  /deep/ .content {
    padding: 32px;

    @media (max-width: 1100px) {
      padding: 32px 16px !important;
      width: 100%;
      margin: 0;
    }
  }
}
.button-submit-newsletter-group {
  display: flex;
  align-items: center;
  justify-content: center;
  .button-submit-newsletter {
    border-radius: 4px;
    font-family: 'lato-bold', sans-serif;
    font-size: 14px;
    letter-spacing: normal;
    text-align: center;
    height: 36px;
    width: 153px;
    margin: 0 6px;
  }
}
#undertone-modal.modal--newsletter ::v-deep {
  .modal-dialog {
    width: 442px;
    height: 383px;
  }
  .modal-content {
    padding: 15px;
  }
  .modal-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .modal-heading {
      font-size: 14px;
      letter-spacing: normal;
      margin-bottom: 0;
      font-family: 'lato-bold', sans-serif;
    }
  }
  .modal-text {
    font-family: 'Lato-regular', sans-serif;
    font-size: 14px;
    text-align: left;
    margin-bottom: 16px;
    margin-top: 0;
    line-height: 24px;
  }
  .items.newsletter-content {
    > .container > .field {
      display: flex;
    }
    input.checkbox::after {
      top: 0;
    }
  }
  .button-group-inline {
    margin-top: 24px;
    .button-minimalis {
      font-size: 13px;
      letter-spacing: normal;
      &.light {
        color: #231f20;
        border-color: #231f20;
        margin-right: 13px;
      }
    }
  }
  .newsletter-content {
    width: 292px;
    text-align: left;
    font-family: 'Lato-regular';
    font-size: 14px;
    .field {
      margin-bottom: 20px;
    }
  }
  @media (max-width: 991px) {
    .modal-dialog {
      max-width: 95vw;
      margin: auto;
    }
    .content-wrapper {
      padding: 0 16px;
    }
    .content {
      padding: 32px 16px !important;
    }
    .modal-heading {
      font-size: 14px;
      letter-spacing: normal;
      text-align: center;
    }
    .newsletter-content {
      max-width: 292px;
      width: 100%;
    }
  }
}
</style>
